module.exports = __webpack_public_path__ + "static/media/nav1.40a2c7db.png";